import type { HawbIssue, HawbRef } from "#/types/manifest";
import type { TFunction } from "i18next";

/** Item status set by a complete C72 Validate exit; mirrors tma-be `HAWB_EXITED_STATUS`. */
export const HAWB_EXITED_STATUS = "exited";

/** "235-11111111 / 123A", or just the AWB when the consignment has no HAWB. */
export const formatHawbLabel = (hawb: Pick<HawbRef, "awb_number" | "hawb_number">): string =>
  hawb.hawb_number ? `${hawb.awb_number} / ${hawb.hawb_number}` : hawb.awb_number;

/** Plain-language sentence for one exit or release problem. */
export const formatHawbIssue = (issue: HawbIssue, t: TFunction): string =>
  t(`manifests.issues.${issue.code}`, { count: issue.count ?? 0 });
